import { combineReducers } from 'redux';
import search from './search';
import language from './language';
import subscriptions from './subscriptions';

export default combineReducers({
  search, language, subscriptions
});